export const SUBWAY_TEHRAN_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tehran_feb_1_2022.svg';
export const SUBWAY_TEHRAN_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tehran_night_feb_1_2022.svg';

export const SUBWAY_TABRIZ_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tabriz_march_6_2022.svg';
export const SUBWAY_TABRIZ_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tabriz_night_march_6_2022.svg';

export const SUBWAY_MASHHAD_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_mashhad_feb_1_2022.svg';
export const SUBWAY_MASHHAD_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_mashhad_night_feb_1_2022.svg';

export const SUBWAY_SHIRAZ_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_shiraz_march_6_2022.svg';
export const SUBWAY_SHIRAZ_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_shiraz_night_march_6_2022.svg';

export const SUBWAY_ISFAHAN_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_isfahan_feb_1_2022.svg';
export const SUBWAY_ISFAHAN_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_isfahan_night_feb_1_2022.svg';

export const TEHRAN_CITY = 'tehran';
export const ISFAHAN_CITY = 'isfahan';
export const MASHHAD_CITY = 'mashhad';
export const TABRIZ_CITY = 'tabriz';
export const SHIRAZ_CITY = 'shiraz';
